module.exports = __webpack_public_path__ + "static/media/img0013.ce4bc615.jpg";